import React, { useEffect, useState } from "react";
import MainLayout from "../layout/MainLayout";
import { API_BASE } from "../config/orbisConfig";



function OrbisAdminUXStyle() {
    return (
        <style>{`
            .orbis-admin-page{
                min-height:100vh;
                background:#041426;
                color:#f5fbff;
                padding:24px;
            }
            .orbis-admin-wrap{
                max-width:1500px;
                margin:0 auto;
                display:flex;
                flex-direction:column;
                gap:24px;
            }
            .orbis-admin-hero{
                background:linear-gradient(135deg,#03111f 0%,#031a2f 55%,#04223d 100%);
                border:1px solid rgba(11,93,140,.8);
                box-shadow:0 20px 45px rgba(0,0,0,.28);
                border-radius:28px;
                padding:28px;
                display:flex;
                align-items:flex-start;
                justify-content:space-between;
                gap:20px;
            }
            .orbis-admin-eyebrow{
                display:inline-flex;
                align-items:center;
                gap:12px;
                color:#d4af37;
                text-transform:uppercase;
                letter-spacing:.24em;
                font-size:12px;
                font-weight:800;
                margin-bottom:12px;
            }
            .orbis-admin-eyebrow::before{
                content:"";
                width:40px;
                height:1px;
                background:#d4af37;
                display:inline-block;
            }
            .orbis-admin-title{
                font-size:36px;
                line-height:1.05;
                font-weight:900;
                color:#fff;
                margin:0;
                letter-spacing:-.03em;
            }
            .orbis-admin-subtitle{
                margin-top:12px;
                color:#d7e8f6;
                font-size:14px;
                line-height:1.65;
                max-width:860px;
            }
            .orbis-admin-page .card,
            .orbis-admin-page .bg-white,
            .orbis-admin-page .rounded-xl,
            .orbis-admin-page .rounded-2xl{
                border-color:#0b4d78 !important;
            }
            .orbis-admin-page .card,
            .orbis-admin-page .bg-white{
                background:#04192b !important;
                color:#f5fbff !important;
                box-shadow:0 12px 30px rgba(0,0,0,.24) !important;
            }
            .orbis-admin-page .card-header-inline{
                background:#031425 !important;
                border-bottom:1px solid #0b4d78 !important;
            }
            .orbis-admin-page h1,
            .orbis-admin-page h2,
            .orbis-admin-page h3,
            .orbis-admin-page .card-title,
            .orbis-admin-page .font-semibold{
                color:#ffffff !important;
            }
            .orbis-admin-page p,
            .orbis-admin-page .text-gray-500,
            .orbis-admin-page .text-gray-600,
            .orbis-admin-page .text-slate-500,
            .orbis-admin-page .text-slate-600{
                color:#9fc4df !important;
            }
            .orbis-admin-page label{
                color:#8fb9da !important;
                font-weight:700;
            }
            .orbis-admin-page input,
            .orbis-admin-page select,
            .orbis-admin-page textarea{
                background:#0b2740 !important;
                color:#fff !important;
                border-color:#0b5f91 !important;
            }
            .orbis-admin-page input::placeholder,
            .orbis-admin-page textarea::placeholder{
                color:#7ea8c7 !important;
            }
            .orbis-admin-page input:focus,
            .orbis-admin-page select:focus,
            .orbis-admin-page textarea:focus{
                border-color:#d4af37 !important;
                box-shadow:0 0 0 2px rgba(212,175,55,.18) !important;
                outline:none !important;
            }
            .orbis-admin-page select option{
                background:#061a2f;
                color:#fff;
            }
            .orbis-admin-page button,
            .orbis-admin-page .btn{
                border-color:#24537a !important;
            }
            .orbis-admin-page .btn,
            .orbis-admin-page button:not(.unstyled){
                border-radius:999px;
            }
            .orbis-admin-page .btn-primary,
            .orbis-admin-page .bg-cani-primary{
                background:#d4af37 !important;
                color:#081a2b !important;
                border-color:#d4af37 !important;
                font-weight:800;
            }
            .orbis-admin-page .btn-secondary,
            .orbis-admin-page .border,
            .orbis-admin-page button{
                border-color:#24537a;
            }
            .orbis-admin-page table{
                border-collapse:separate;
                border-spacing:0;
                background:#061a2f !important;
            }
            .orbis-admin-page table thead th{
                position:sticky;
                top:0;
                z-index:10;
                background:#061a2f !important;
                color:#8fb9da !important;
                border-bottom:1px solid #24587c !important;
                text-transform:uppercase;
                letter-spacing:.13em;
            }
            .orbis-admin-page table tbody tr{
                transition:background .18s ease, box-shadow .18s ease;
                background:#08233d !important;
            }
            .orbis-admin-page table tbody tr:nth-child(even){
                background:#092a49 !important;
            }
            .orbis-admin-page table tbody tr:hover{
                background:rgba(56,189,248,.075) !important;
                box-shadow:inset 3px 0 0 #d4af37;
            }
            .orbis-admin-page table tbody td{
                border-top:1px solid #24587c !important;
                color:#f5fbff !important;
                background:transparent !important;
            }
            .orbis-admin-page .scroll-shell{
                background:#04192b !important;
                border-color:#24587c !important;
            }
            .orbis-admin-page .top-scroll{
                background:#061a2f !important;
                border-bottom-color:#24587c !important;
            }
            .orbis-admin-page .avatar,
            .orbis-admin-page .avatar-fallback{
                border-color:#0b5f91 !important;
                background:#0b2740 !important;
                color:#d9f4ff !important;
            }
            .orbis-admin-page .alert-info{
                border:1px solid #0ea5e9 !important;
                background:#0b2740 !important;
                color:#d9f4ff !important;
            }
            .orbis-admin-page ::-webkit-scrollbar{height:10px;width:10px}
            .orbis-admin-page ::-webkit-scrollbar-track{background:#061a2f;border-radius:999px}
            .orbis-admin-page ::-webkit-scrollbar-thumb{background:#2b638e;border-radius:999px}
            .orbis-admin-page ::-webkit-scrollbar-thumb:hover{background:#d4af37}

            @media(max-width:768px){
                .orbis-admin-page{padding:12px}
                .orbis-admin-hero{padding:20px;flex-direction:column}
                .orbis-admin-title{font-size:30px}
            }
        `}</style>
    );
}

const SettingsPage = () => {
    const [displayName, setDisplayName] = useState("Ale Eiby");
    const [role, setRole] = useState("Líder de proyectos");

    useEffect(() => {
        const savedName = localStorage.getItem("cani_displayName");
        const savedRole = localStorage.getItem("cani_role");
        if (savedName) setDisplayName(savedName);
        if (savedRole) setRole(savedRole);
    }, []);

    const handleSave = (e) => {
        e.preventDefault();
        localStorage.setItem("cani_displayName", displayName);
        localStorage.setItem("cani_role", role);
        alert("Preferencias guardadas (localmente en este navegador).");
    };

    return (
        <MainLayout>
            <OrbisAdminUXStyle />
            <div className="orbis-admin-page">
                <div className="orbis-admin-wrap">
                    <div className="orbis-admin-hero">
                        <div>
                            <div className="orbis-admin-eyebrow">Administración</div>
                            <h2 className="orbis-admin-title">Configuración</h2>
                            <p className="orbis-admin-subtitle">
                                Ajusta tus preferencias básicas de usuario y visualización de la plataforma.
                            </p>
                        </div>
                    </div>

                    <div className="card rounded-[24px] p-5 max-w-2xl">
                        <form onSubmit={handleSave} className="space-y-4 text-xs">
                            <div>
                                <label className="block mb-1">Nombre mostrado</label>
                                <input
                                    type="text"
                                    value={displayName}
                                    onChange={(e) => setDisplayName(e.target.value)}
                                    className="w-full border rounded-lg px-3 py-2 text-xs"
                                />
                            </div>

                            <div>
                                <label className="block mb-1">Rol / descripción</label>
                                <input
                                    type="text"
                                    value={role}
                                    onChange={(e) => setRole(e.target.value)}
                                    className="w-full border rounded-lg px-3 py-2 text-xs"
                                />
                            </div>

                            <p className="text-[11px]">
                                Nota: Esta configuración se guarda solo en este navegador usando
                                localStorage. Para una versión multiusuario real, se conectaría a
                                un backend.
                            </p>

                            <div className="flex justify-end gap-2 pt-2">
                                <button type="submit" className="btn btn-primary px-4 py-2 text-xs font-medium">
                                    Guardar cambios
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default SettingsPage;
